//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
export default {
  name: 'static-content-wrapper',
  mixins: [i18n],
  props: {
    field: Object,
    designer: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designState: {
      type: Boolean,
      default: false
    },
    displayStyle: {
      type: String,
      default: 'block'
    },
    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */type: String,
      default: ''
    }
  },
  computed: {
    selected: function selected() {
      return !!this.designer && this.field.id === this.designer.selectedId;
    },
    customClass: function customClass() {
      return !!this.field.options.customClass ? this.field.options.customClass.join(' ') : '';
    }
  },
  methods: {
    selectField: function selectField(field) {
      if (!!this.designer) {
        this.designer.setSelected(field);
        this.designer.emitEvent('field-selected', this.parentWidget); //发送选中组件的父组件对象
      }
    },
    selectParentWidget: function selectParentWidget() {
      if (this.parentWidget) {
        this.designer.setSelected(this.parentWidget);
      } else {
        this.designer.clearSelected();
      }
    },
    moveUpWidget: function moveUpWidget() {
      this.designer.moveUpWidget(this.parentList, this.indexOfParentList);
      this.designer.emitHistoryChange();
    },
    moveDownWidget: function moveDownWidget() {
      this.designer.moveDownWidget(this.parentList, this.indexOfParentList);
      this.designer.emitHistoryChange();
    },
    removeFieldWidget: function removeFieldWidget() {
      var _this = this;
      console.log('removeFieldWidget', this.designer.selectedWidgetName);
      if (!!this.parentList) {
        var fieldRefName = this.designer.selectedWidgetName;
        var nextSelected = null;
        if (this.parentList.length === 1) {
          if (!!this.parentWidget) {
            nextSelected = this.parentWidget;
          }
        } else if (this.parentList.length === 1 + this.indexOfParentList) {
          nextSelected = this.parentList[this.indexOfParentList - 1];
        } else {
          nextSelected = this.parentList[this.indexOfParentList + 1];
        }
        this.$nextTick(function () {
          _this.parentList.splice(_this.indexOfParentList, 1);
          //if (!!nextSelected) {
          _this.designer.setSelected(nextSelected);
          //}

          _this.designer.formWidget.deleteWidgetRef(fieldRefName); //删除组件ref！！！
          _this.designer.emitHistoryChange();
        });
      }
    }
  }
};